import React from "react";
import PropTypes from "prop-types";

import { Typography } from "@mui/material";

const instructions = {
  title: "Your name will be displayed at the top of your profile.",
  description: "Your bio is a short description that appears below your name. Keep it concise and engaging.",
  cta: "A call-to-action button is a prominent button visitors can click to take your desired action.",
  logo: "Choose a profile picture that represents you or your brand. Square images work best (1:1 ratio).",
  cover_image: "Choose an image that represents your brand or event. Recommended size: 1200 × 400 pixels.",
  social_links: "Manage your social media links or add new ones below.",
};

const Instructions = ({ name }) => {
  return (
    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
      {instructions[name]}
    </Typography>
  );
};

Instructions.propTypes = {
  name: PropTypes.string,
};

export default Instructions;
